import { render, staticRenderFns } from "./BaseHeaderMenuStructure.vue?vue&type=template&id=42c4a81e&scoped=true&"
import script from "./BaseHeaderMenuStructure.vue?vue&type=script&lang=js&"
export * from "./BaseHeaderMenuStructure.vue?vue&type=script&lang=js&"
import style0 from "./BaseHeaderMenuStructure.vue?vue&type=style&index=0&id=42c4a81e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42c4a81e",
  null
  
)

export default component.exports